/**
 * A map about to be opened. The finger goes down on a card a good tenth of a second before the
 * tap is a tap; in that time the plan is read from the store and decoded, so the editor has it
 * the moment it is made — and the zoom into the map flies the real, sharp plan almost from the
 * start (its marks on the plan lifted under them, lift.ts). A finger that goes on to scroll instead costs nothing but a decode that is thrown away.
 */
import { mapImage } from './maps.ts';
import { liftInWorker } from '../render/lift.ts';

interface Warm {
  id: string;
  blob: Promise<Blob | null>;
  bitmap: Promise<ImageBitmap | null>;
  timer: number;
}
let warm: Warm | null = null;

function release(): void {
  const w = warm;
  if (!w) return;
  warm = null;
  clearTimeout(w.timer);
  void w.bitmap.then((b) => b?.close());
}

export function warmMap(id: string): void {
  if (warm?.id === id) return;
  release();
  const blob = mapImage(id).then((b) => b ?? null, () => null);
  const bitmap = blob.then((b) => (b ? createImageBitmap(b, { imageOrientation: 'from-image' }) : null)).catch(() => null);
  // and the plan lifted under its marks, in its worker (the editor takes it up by the same key)
  void blob.then((b) => b && liftInWorker(`${id}:${b.size}`, b));
  warm = { id, blob, bitmap, timer: window.setTimeout(release, 4000) };
}

/** The plan being warmed for this map, if it is — now the caller's (it closes the bitmap). */
export function takeWarm(id: string): { blob: Promise<Blob | null>; bitmap: Promise<ImageBitmap | null> } | null {
  if (warm?.id !== id) return null;
  const w = warm;
  warm = null;
  clearTimeout(w.timer);
  return w;
}
